module.exports = __webpack_public_path__ + "static/media/react.0ad1d17f.png";